// Basic fetch wrapper that automatically adds JWT
export const normalizeApiUrl = (url) => url.replace(/\/api\/v1\/api\/v1(?=\/|$)/g, '/api/v1');

export const createHeaders = (idToken) => ({
  "Content-Type": "application/json",
  ...(idToken ? { "Authorization": `Bearer ${idToken}` } : {})
});

export const apiGet = async (url, idToken) => {
  const requestUrl = normalizeApiUrl(url);
  const res = await fetch(requestUrl, { method: "GET", headers: createHeaders(idToken) });
  if (!res.ok) throw new Error(`GET ${requestUrl} failed: ${res.statusText}`);
  return res.json();
};

export const apiPost = async (url, data, idToken) => {
  const requestUrl = normalizeApiUrl(url);
  const res = await fetch(requestUrl, { method: "POST", headers: createHeaders(idToken), body: JSON.stringify(data) });
  if (!res.ok) throw new Error(`POST ${requestUrl} failed: ${res.statusText}`);
  return res.json();
};
